export default __webpack_public_path__ + "static/Home-Top-56cffaab7bcd63a92d12351e1b947d4a.jpg";